export const userConstants = {
  SIGNUP_REQUEST: 'USERS_SIGNUP_REQUEST',
  SIGNUP_SUCCESS: 'USERS_SIGNUP_SUCCESS',
  SIGNUP_FAILURE: 'USERS_SIGNUP_FAILURE',

  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  LOGOUT: 'USERS_LOGOUT',

  GETALL_REQUEST: 'TEACHERS_GETALL_REQUEST',
  GETALL_SUCCESS: 'TEACHERS_GETALL_SUCCESS',
  GETALL_FAILURE: 'TEACHERS_GETALL_FAILURE',

  GET_BY_ID_REQUEST: 'TEACHER_GET_BY_ID_REQUEST',
  GET_BY_ID_SUCCESS: 'TEACHER_GET_BY_ID_SUCCESS',
  GET_BY_ID_FAILURE: 'TEACHER_GET_BY_ID_FAILURE',

  CREATE_REQUEST: 'USERS_CREATE_REQUEST',
  CREATE_SUCCESS: 'USERS_CREATE_SUCCESS',
  CREATE_FAILURE: 'USERS_CREATE_FAILURE',

  UPDATE_REQUEST: 'USERS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'USERS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'USERS_UPDATE_FAILURE',

  DELETE_REQUEST: 'USERS_DELETE_REQUEST',
  DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
  DELETE_FAILURE: 'USERS_DELETE_FAILURE',

  CHANGE_PASSWORD_REQUEST: 'USERS_CHANGE_PASSWORD_REQUEST',
  CHANGE_PASSWORD_SUCCESS: 'USERS_CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_FAILURE: 'USERS_CHANGE_PASSWORD_FAILURE'
};
